export default __webpack_public_path__ + "static/media/equipments.d4ee7d72.jpg";